// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"dPygGk","panelContainer":"_3KXbeB","title":"_3Q2LRr","generateOutlineAttributes":"_3FTCTo","body":"_33VYF9"};